import { PrevNextButtons } from "app/components/organisms/PrevNextButtons";
import { FC } from "react";
import { Text, View } from "react-native";
import { Button, ButtonText } from "ui/gluestack/button";

interface CalendarToolbarProps {
  currentTitle: string;
  currentView: string;
  switchView: (view: string) => void;
  onPrev: () => void;
  onNext: () => void;
}

export const CalendarToolbar: FC<CalendarToolbarProps> = ({
  currentTitle,
  currentView,
  switchView,
  onPrev,
  onNext,
}) => {
  return (
    <View className="flex-row items-start justify-between mb-4 gap-x-2">
      <View className="flex-row items-center">
        <PrevNextButtons onPrev={onPrev} onNext={onNext} />
        <Text className="text-lg font-bold ml-2 sm:ml-5">{currentTitle}</Text>
      </View>

      <View className="flex-row gap-2">
        {["timeGridDay", "timeGridWeek", "dayGridMonth", "multiMonthYear"].map(
          (view) => (
            <Button
              key={view}
              onPress={() => switchView(view)}
              action="tertiary"
              variant="solid"
              size="xs"
              className={`rounded-xl ${currentView === view ? "bg-tertiary-700" : ""}`}
            >
              <ButtonText className={currentView === view ? "text-white" : ""}>
                {view === "timeGridDay"
                  ? "Day"
                  : view === "timeGridWeek"
                    ? "Week"
                    : view === "dayGridMonth"
                      ? "Month"
                      : "Year"}
              </ButtonText>
            </Button>
          ),
        )}
      </View>
    </View>
  );
};
